"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Recyclon = void 0;
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const Resources_1 = require("../../Resources");
const SelectOption_1 = require("../../inputs/SelectOption");
const OrOptions_1 = require("../../inputs/OrOptions");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class Recyclon extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.RECYCLON,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.BUILDING],
            startingMegaCredits: 38,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            productionBox: Units_1.Units.of({ steel: 1 }),
            metadata: {
                cardNumber: 'R26',
                description: 'You start with 38 M€ and 1 steel production.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.megacredits(38).nbsp().production((pb) => pb.steel(1));
                    b.corpBox('effect', (ce) => {
                        ce.effect('When you play a building tag, including this, gain 1 microbe to this card, or remove 2 microbes here and raise your plant production 1 step.', (eb) => {
                            eb.building().played.colon().microbes(1).or();
                            eb.microbes(2).digit.startEffect.production((pb) => pb.plants(1));
                        });
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.STEEL, 1);
        player.addResourceTo(this);
        return undefined;
    }
    onCardPlayed(player, card) {
        return this._onCardPlayed(player, card);
    }
    onCorpCardPlayed(player, card) {
        return this._onCardPlayed(player, card);
    }
    _onCardPlayed(player, card) {
        if (card.tags.includes(Tags_1.Tags.BUILDING) === false || !player.isCorporation(this.name)) {
            return undefined;
        }
        const resourceCount = player.getResourcesOnCard(this);
        const buildingTagCount = card.tags.filter((tag) => tag === Tags_1.Tags.BUILDING).length;
        if (resourceCount + buildingTagCount < 3) {
            player.addResourceTo(this, { qty: buildingTagCount, log: true });
            return undefined;
        }
        const addResource = new SelectOption_1.SelectOption('Add a microbe to Recyclon', 'Add microbe', () => {
            player.addResourceTo(this, { log: true });
            return undefined;
        });
        const spendResource = new SelectOption_1.SelectOption('Remove 2 microbes on Recyclon to increase plant production 1 step', 'Remove microbes', () => {
            player.removeResourceFrom(this, 2);
            player.addProduction(Resources_1.Resources.PLANTS, 1);
            player.game.log('${0} removed 2 microbes from ${1} to increase plant production 1 step', (b) => b.player(player).cardName(this.name));
            return undefined;
        });
        if (buildingTagCount === 2) {
            if (resourceCount === 1) {
                player.addResourceTo(this, { log: true });
                return new OrOptions_1.OrOptions(spendResource, addResource);
            }
            else {
                const addTwoMicrobes = new SelectOption_1.SelectOption('Add 2 microbes to Recyclon', 'Select', () => {
                    player.addResourceTo(this, { qty: buildingTagCount, log: true });
                    return undefined;
                });
                const removeTwoMicrobesAndAddOneMicrobe = new SelectOption_1.SelectOption('Remove 2 microbes on Recyclon to increase plant production 1 step, then add 1 microbe', 'Select', () => {
                    player.removeResourceFrom(this, 2);
                    player.addProduction(Resources_1.Resources.PLANTS, 1);
                    player.game.log('${0} removed 2 microbes from ${1} to increase plant production 1 step', (b) => b.player(player).cardName(this.name));
                    player.addResourceTo(this, { log: true });
                    return undefined;
                });
                const removeFourMicrobes = new SelectOption_1.SelectOption('Remove 4 microbes on Recyclon to increase plant production 2 steps', 'Select', () => {
                    player.removeResourceFrom(this, 4);
                    player.addProduction(Resources_1.Resources.PLANTS, 2);
                    player.game.log('${0} removed 4 microbes from ${1} to increase plant production 2 steps', (b) => b.player(player).cardName(this.name));
                    return undefined;
                });
                if (resourceCount >= 4) {
                    return new OrOptions_1.OrOptions(removeFourMicrobes, removeTwoMicrobesAndAddOneMicrobe, addTwoMicrobes);
                }
                else {
                    return new OrOptions_1.OrOptions(removeTwoMicrobesAndAddOneMicrobe, addTwoMicrobes);
                }
            }
        }
        return new OrOptions_1.OrOptions(spendResource, addResource);
    }
}
exports.Recyclon = Recyclon;
//# sourceMappingURL=Recyclon.js.map